<button
  class="btn-{{variant()}} {{paddingSize()}} {{extraClass()}} {{flexDirection()}} flex gap-2 justify-center w-full font-bold text-base border rounded-lg border-transparent hover:cursor-pointer group {{ noWhitespace() ? 'whitespace-nowrap' : '' }}"
  [disabled]="disabled()"
  [class.btn-disabled]="disabled()"
  (click)="buttonClick.emit()"
>
  <span class="{{extraClassForText()}}">{{ text() }} </span>
  @if(icon()){
  <icon [name]="icon()" [size]="iconSize()" class="my-auto"></icon>
  }
</button>
